<template>
  <div id="wrap" v-loading="loading">
    <div class="flex flex-start flex-wrap">
      <div>
        <el-form :inline="true">
          <el-form-item label="姓名：">
            <el-input
              placeholder="请输入"
              v-model="queryParam.employeeName"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-form :inline="true">
          <el-form-item label="部门：">
            <el-select v-model="queryParam.deptName">
              <el-option value="" label="全部">全部</el-option>
              <el-option
                v-for="item in depts"
                :label="item.deptName"
                :value="item.deptName"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-form :inline="true">
          <el-form-item label="聘用方式：">
            <el-select v-model="queryParam.hireType">
              <el-option value="" label="全部"></el-option>
              <el-option
                v-for="item in hireTypes"
                :label="item.dictName"
                :value="item.dictCode"
                :key="item.dictCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button type="primary" @click="search"> 查询 </el-button>
        <el-button type="primary" @click="resetQuery"> 重置 </el-button>
      </div>
    </div>

    <div class="flex flex-start" style="margin-top: 15px">
      <el-button type="primary" @click="add_people"> 新增</el-button>
      <el-button type="primary" @click="dialogFormVisible_daoru = true"
        >批量导入
      </el-button>
      <!--      <el-button type="primary" @click="connectEmployee()"
      ><i class="el-icon-plus"></i> 关联项目
      </el-button
      >-->
    </div>

    <div class="flex flex-justify title_box">
      <div>
        <i class="el-icon-warning" style="color: #4988df">
          已选择 <span>{{ selectLength }}</span> 项
        </i>
      </div>
      <div>
        <!-- <el-link
          type="primary"
          :underline="false"
          @click="batchUpdateProjectJoinTime()"
        >批量设置参与项目时间
        </el-link
        > -->
        <el-link
          type="primary"
          style="margin-left: 20px"
          :underline="false"
          @click="batchRemove()"
          >移除
        </el-link>
      </div>
    </div>

    <!-- 关联人员 -->
    <el-dialog
      title="选择部门与人员"
      :visible.sync="dialogFormVisible_add"
      center
      width="40%"
    >
      <div class="dialog_content">
        <!-- 使用树形穿梭框组件 -->
        <tree-transfer
          :title="title"
          :from_data="fromData"
          :to_data="toData"
          :defaultProps="{ label: 'label' }"
          @addBtn="add"
          @removeBtn="remove"
          :mode="mode"
          height="340px"
          filter
          openAll
        >
        </tree-transfer>
        <!-- <el-transfer
          filterable
          filter-placeholder="请输入城市拼音"
          v-model="value"
          class="eltransfer"
        >
        </el-transfer> -->
      </div>
      <div slot="footer" class="dialog-footer flex flex-justify">
        <div>
          <el-button type="primary" @click="dialog_add">批量导入</el-button>
        </div>
        <div>
          <el-button @click="dialogFormVisible_add = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible_add = false"
            >确 认
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 新增人员 -->
    <el-dialog
      title="人员信息"
      :visible.sync="add_people_message"
      center
      width="40%"
      loading="loading"
    >
      <div class="dialog_content">
        <el-form
          class="flex flex flex-justify flex-wrap form_box"
          label-position="top"
          :model="employeeForm"
          :rules="employeeRules"
          ref="employeeRuleForm"
        >
          <el-form-item label="姓名：" prop="employeeName">
            <el-input
              placeholder="请输入"
              v-model="employeeForm.employeeName"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别：" prop="employeeSex">
            <el-select v-model="employeeForm.employeeSex">
              <el-option
                v-for="item in sexs"
                :label="item.label"
                :key="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工号：" prop="employeeNumber">
            <el-input
              placeholder="请输入"
              v-model="employeeForm.employeeNumber"
              :disabled="numberDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item label="人员聘用方式：" prop="hireType">
            <el-radio-group v-model="employeeForm.hireType">
              <el-radio
                v-for="item in hireTypes"
                :label="item.dictCode"
                :value="item.dictCode"
                :key="item.dictCode"
              >
                {{ item.dictName }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="部门：" prop="deptName">
            <el-input
              placeholder="请输入"
              v-model="employeeForm.deptName"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="学历："
            prop="educationBackground"
            aria-placeholder="请选择"
          >
            <el-select v-model="employeeForm.educationBackground">
              <el-option
                v-for="item in educationBackgrounds"
                :label="item.dictName"
                :value="item.dictCode"
                :key="item.dictCode"
                >{{ item.dictName }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入职时间：" prop="entryTime">
            <el-date-picker
              v-model="employeeForm.entryTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间"
              :picker-options="start"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="离职时间：" prop="leaveTime">
            <el-date-picker
              v-model="employeeForm.leaveTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间"
              :picker-options="end"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="手机号：" prop="mobileNumber">
            <el-input
              placeholder="请输入"
              v-model="employeeForm.mobileNumber"
            ></el-input>
          </el-form-item>
          <el-form-item label="职称：" prop="title">
            <el-select placeholder="请选择" v-model="employeeForm.title">
              <el-option
                v-for="item in titles"
                :key="item.dictCode"
                :label="item.dictName"
                :value="item.dictCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职务：" prop="duty">
            <el-input
              placeholder="请输入"
              v-model="employeeForm.duty"
            ></el-input>
          </el-form-item>
          <el-form-item label="专业：" prop="major">
            <el-input
              placeholder="请输入"
              v-model="employeeForm.major"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="人员来源："
            style="width: 100%"
            prop="employeeSource"
          >
            <el-radio-group v-model="employeeForm.employeeSource">
              <el-radio
                v-for="item in employeeSources"
                :label="item.dictCode"
                :value="item.dictCode"
                :key="item.dictCode"
                >{{ item.dictName }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quxiao">返 回</el-button>
        <el-button type="primary" @click="saveEmployee">保 存 </el-button>
      </div>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog
      title="批量导入"
      :visible.sync="dialogFormVisible_daoru"
      center
      width="44%"
    >
      <div class="dialog_content">
        <div class="download" style="margin-top: 20px; line-height: 25px">
          <div>填写需要导入的数据</div>
          <div style="color: #a3adb9">
            请按照数据模板的格式准备导入数据,模板中的表头名称不可更改,表头行不能删除,表格格式不能修改
          </div>
          <div>
            <el-link type="primary" :underline="false" @click="importTemplate"
              >下载模板</el-link
            >
          </div>
        </div>
        <div class="upload" style="margin-top: 20px; line-height: 25px">
          <div>上传填好的表格</div>
          <div style="color: #a3adb9">
            文件后缀名必须为xls或xsx (即Excel格式) ,文件大小不得大于5M
          </div>
          <el-upload
            class="upload-demo"
            :action="employeeImportUrl"
            :on-success="uploadSuccess"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
            ref="upload"
          >
            <el-link type="primary" :underline="false">上传文件</el-link>
          </el-upload>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible_daoru = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible_daoru = false"
          >下一步
        </el-button>
      </div>
    </el-dialog>

    <!-- 设置参与项目时间 -->
    <el-dialog
      title="人员项目时间设定"
      :visible.sync="timeDialogVisible"
      center
      width="40%"
    >
      <div class="dialog_content" style="width: 80%; margin: 0 auto">
        <el-form label-width="35%" label-position="left">
          <el-form-item label="姓名">
            <el-input
              placeholder="请输入"
              readonly
              v-model="employeeName"
            ></el-input>
          </el-form-item>
          <el-form-item label="加入项目日期">
            <el-date-picker
              v-model="joinTime"
              type="date"
              clearable
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间"
              :picker-options="joinTime_start"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="离开项目日期">
            <el-date-picker
              v-model="leaveTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间"
              :picker-options="leaveTime_end"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateJoinTime()">确定 </el-button>
        <el-button type="primary" @click="resetJoinTime">重置 </el-button>
      </div>
    </el-dialog>

    <el-table
      class="table"
      :data="tableData"
      :header-cell-style="{ background: '#F5F7FA' }"
      stripe
      @selection-change="tableSelect"
      empty-text="暂无数据"
      :row-class-name="tableRowClassName"
      ref="employeeTable"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column label="姓名" prop="employeeName"></el-table-column>
      <el-table-column
        prop="employeeSex"
        :formatter="sexFormatter"
        label="性别"
      ></el-table-column>
      <el-table-column
        prop="employeeNumber"
        label="工号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="部门" prop="deptName"></el-table-column>
      <el-table-column label="学历" prop="ebType"></el-table-column>
      <el-table-column label="聘用方式" prop="hireTypeName"></el-table-column>
      <!-- <el-table-column
        label="项目参与时间"
        prop="entryTime"
        show-overflow-tooltip
        :formatter="projectTimeFormat"
      ></el-table-column> -->

      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            class="green"
            @click="edit(scope.row)"
            >编辑
          </el-button>

          <el-button
            type="text"
            size="small"
            class="red"
            @click="removeEmployee(scope.row.id)"
            >移除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="flex flex-end">
      <el-pagination
        class="pagination"
        background
        layout="prev, pager, next,total"
        :current-page.sync="queryParam.pageNum"
        :page-size.sync="queryParam.pageSize"
        :total="total"
        @current-change="search"
      >
      </el-pagination>
    </div>

    <import-tips
      :show="importOpen"
      :data="importData"
      :succeedNumber="importSucceedNumber"
      :errorNumber="importErrorNumber"
      @importOpnes="importOpnes"
    />
  </div>
</template>

<script>
import treeTransfer from "el-tree-transfer"; // 引入
import {
  getEmployee,
  getDepts,
  saveEmployee,
  removeEmployeeProjectRelation,
  employeeUpdateRelevance,
  deleteEmployee,
} from "./project";
import importTips from "./importTips.vue";
import { getDict } from "./ChinaHigh";
import { importDateDownloadTemplate } from "./fixedAssets";
export default {
  data() {
    return {
      numberDisabled: false,
      start: {
        disabledDate: (time) => {
          if (this.employeeForm.leaveTime) {
            return (
              time.getTime() > new Date(this.employeeForm.leaveTime).getTime()
            );
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      end: {
        disabledDate: (time) => {
          if (this.employeeForm.entryTime) {
            return (
              new Date(this.employeeForm.entryTime).getTime() > time.getTime()
            );
          } else {
            // return time.getTime() > Date.now()
          }
        },
      },
      joinTime_start: {
        disabledDate: (time) => {
          if (this.leaveTime) {
            return time.getTime() > new Date(this.leaveTime).getTime();
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      leaveTime_end: {
        disabledDate: (time) => {
          if (this.joinTime) {
            return new Date(this.joinTime).getTime() > time.getTime();
          } else {
            // return time.getTime() > Date.now()
          }
        },
      },
      mode: "transfer", // transfer addressList
      fromData: [
        {
          id: "1",
          label: "一级 1",
          children: [
            {
              id: "1-1",
              label: "二级 1-1",
              disabled: "false",
              children: [],
            },
            {
              id: "1-2",
              label: "二级 1-2",
              children: [
                {
                  id: "1-2-1",
                  children: [],
                  label: "二级 1-2-1",
                },
                {
                  id: "1-2-2",
                  children: [],
                  label: "二级 1-2-2",
                },
              ],
            },
          ],
        },
      ],
      title: ["全部员工", "项目员工"],
      toData: [],
      selectLength: 0,
      employeeForm: {},
      fileList: [],
      employeeImportUrl: this.mainBaseURL + "/importDate/importEmployees",
      sexs: [
        { value: 1, label: "男" },
        { value: 2, label: "女" },
      ],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        employeeName: "",
        deptName: "",
        hireType: null,
        projectId: "",
      },
      ids: [],
      employeeName: "",
      depts: [],
      hireTypes: [],
      titles: [],
      total: 0,
      // 导入
      dialogFormVisible_daoru: false,
      // 关联人员
      dialogFormVisible_add: false,
      // 参与项目时间
      timeDialogVisible: false,
      // 新增人员信息
      add_people_message: false,
      loading: false,
      radio: "1",
      importOpen: false,
      importData: [],
      importSucceedNumber: 0,
      importErrorNumber: 0,
      input1: "",
      ruleForm: {
        name: "",
      },
      joinTime: "",
      leaveTime: "",
      educationBackgrounds: [],
      employeeSources: [],
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
      },
      tableData: [],
      value: "",
      employeeRules: {
        employeeName: [
          { required: true, message: "请填写该数据", trigger: "blur" },
        ],
        employeeSex: [
          { required: true, message: "请填写该数据", trigger: "change" },
        ],
        employeeNumber: [
          { required: true, message: "请填写该数据", trigger: "blur" },
        ],
        hireType: [
          { required: true, message: "请填写该数据", trigger: "change" },
        ],
        deptName: [
          { required: true, message: "请填写该数据", trigger: "blur" },
        ],
        educationBackground: [
          { required: true, message: "请填写该数据", trigger: "change" },
        ],
        entryTime: [
          { required: true, message: "请填写该数据", trigger: "change" },
        ],
        mobileNumber: [
          {
            required: true,
            message: "请填写正确的手机号",
            trigger: "blur",
          },
          {
            pattern:
              "^((\\+?86)|(\\(\\+86\\)))?(13[012356789][0-9]{8}|15[012356789][0-9]{8}|18[02356789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$",
            message: "请输入正确的手机号",
          },
        ],
      },
      options: [
        {
          value: "1",
          label: "产品一部",
          children: [
            {
              value: "2",
              label: "研发部",
              children: [
                {
                  value: "3",
                  label: "软件",
                },
              ],
            },
          ],
        },
      ],
      importResultVisable: false,
    };
  },

  components: {
    importTips,
    treeTransfer,
  },

  created() {
    this.init();
  },

  methods: {
    importTemplate() {
      importDateDownloadTemplate(9).then((res) => {
        if (res.code == "00000") {
          window.open(res.data, "_blank");
        }
      });
    },
    edit(row) {
      this.numberDisabled = true;
      this.employeeForm = row;
      this.dialogFormVisible_add = false;
      this.add_people_message = true;
    },
    tableSelect(selection) {
      this.selectLength = selection.length;
      console.log(this.selectLength);
    },
    batchRemove() {
      this.ids = [];
      this.employeeName = "";
      this.$refs.employeeTable.selection.forEach((item) => {
        this.ids.push(item.id);
        this.employeeName = this.employeeName + item.employeeName + ",";
      });
      this.employeeName = this.employeeName.substr(
        0,
        this.employeeName.length - 1
      );
      if (this.ids.length > 0) {
        this.$confirm("确认将[" + this.employeeName + "]移出项目吗?", "警告", {
          type: "warning",
        }).then((res) => {
          if (res) {
            this.loading = true;
            deleteEmployee({ ids: this.ids }).then((res) => {
              this.loading = false;
              if (res.code == "00000") {
                this.msgSuccess("删除成功");
                this.search();
              }
            });
          }
        });
      } else {
        this.$message.error("请至少选中一行");
      }
    },
    batchUpdateProjectJoinTime() {
      this.ids = [];
      this.employeeName = "";
      this.$refs.employeeTable.selection.forEach((item) => {
        this.ids.push(item.adeId);
        this.employeeName = this.employeeName + item.employeeName + ",";
      });
      this.employeeName = this.employeeName.substr(
        0,
        this.employeeName.length - 1
      );
      this.joinTime = "";
      this.leaveTime = "";
      if (this.ids.length <= 0) {
        this.$message.error("请至少选中一行");
      } else {
        this.timeDialogVisible = true;
      }
    },
    connectEmployee() {
      this.dialogFormVisible_add = true;
    },
    quxiao() {
      this.add_people_message = false;
      this.numberDisabled = false;
      this.search();
    },
    updateJoinTime() {
      this.loading = true;
      employeeUpdateRelevance({
        ids: this.ids,
        joinTime: this.joinTime,
        leaveTime: this.leaveTime,
      }).then((res) => {
        this.loading = false;
        if (res.code == "00000") {
          this.msgSuccess("设置成功");

          this.search();
          this.timeDialogVisible = false;
        }
      });
    },
    init() {
      // this.queryParam.projectId = sessionStorage.getItem("zt_jjkc_project_id");
      //初始化表格
      this.search();
      //获取部门
      getDepts().then((res) => {
        this.depts = res.data;
      });
      //获取字典-聘用类型
      getDict({ type: "hire_type" }).then((res) => {
        this.hireTypes = res.data;
      });
      //获取字典-学历
      getDict({ type: "education_background" }).then((res) => {
        this.educationBackgrounds = res.data;
      });
      //获取字典-人员来源
      getDict({ type: "employee_source" }).then((res) => {
        this.employeeSources = res.data;
      });
      //获取字典-职称
      getDict({ type: "professional_title" }).then((res) => {
        this.titles = res.data;
      });
    },
    saveEmployee() {
      this.$refs["employeeRuleForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          // this.employeeForm.projectId = sessionStorage.getItem("zt_jjkc_project_id");
          // console.log(sessionStorage.getItem("zt_jjkc_project_id"));
          saveEmployee(this.employeeForm).then((res) => {
            this.loading = false;
            if (res.code == "00000") {
              this.msgSuccess("操作成功");
              this.add_people_message = false;
              this.search();
            }
          });
        } else {
          this.$message.error("数据不完整");
        }
      });
      this.numberDisabled = false;
    },
    setProjectJoinTime(adeId, employeeName, joinTime, leaveTime) {
      if (adeId) {
        this.ids = [];
        this.ids.push(adeId);
        this.joinTime = joinTime;
        this.leaveTime = leaveTime;
        this.employeeName = employeeName;
        this.timeDialogVisible = true;
      } else {
        this.$message.error("员工不属于该项目,无法设置");
      }
    },
    removeEmployee(id) {
      this.$confirm("确认将该员工移出项目吗?", "警告", {
        type: "warning",
      }).then((res) => {
        if (res) {
          let idList = [];
          idList.push(id);
          deleteEmployee({ ids: idList }).then((res) => {
            if (res.code == "00000") {
              this.msgSuccess("删除成功");
              this.search();
            }
          });
        }
      });
    },
    projectTimeFormat(row, col) {
      return (
        (row.joinTime ? row.joinTime : "未设置") +
        "至" +
        (row.adeLeaveTime ? row.adeLeaveTime : "未设置")
      );
    },
    sexFormatter(row, col) {
      return row.employeeSex == 1 ? "男" : "女";
    },
    search() {
      this.loading = true;
      getEmployee(this.queryParam).then((res) => {
        this.loading = false;
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        employeeName: "",
        deptName: "",
        hireType: null,
      };
      this.search();
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "background:#fff";
      } else {
        return "background:#F5F7FA";
      }
    },
    dialog_add() {
      this.dialogFormVisible_add = false;
      this.dialogFormVisible_daoru = true;
    },
    add_people() {
      this.employeeForm = {};
      this.dialogFormVisible_add = false;
      this.add_people_message = true;
    },
    // 切换模式 现有树形穿梭框模式transfer 和通讯录模式addressList
    changeMode() {
      if (this.mode == "transfer") {
        this.mode = "addressList";
      } else {
        this.mode = "transfer";
      }
    },
    // 监听穿梭框组件添加
    add(fromData, toData, obj) {
      console.log(fromData);
      console.log(toData);
    },
    // 监听穿梭框组件移除
    remove(fromData, toData, obj) {
      // 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的{keys,nodes,halfKeys,halfNodes}对象
      // 通讯录模式addressList时，返回参数为右侧收件人列表、右侧抄送人列表、右侧密送人列表
      console.log("fromData:", fromData);
      console.log("toData:", toData);
      console.log("obj:", obj);
    },
    handleRemove(file, fileList) {},
    handlePreview(file) {},
    handleExceed(files, fileList) {
      this.$message.error("超出限制文件个数");
    },
    beforeRemove(file, fileList) {},
    uploadSuccess(res, file) {
      if (res.code == "00000") {
        this.dialogFormVisible_daoru = false;
        this.$refs.upload.clearFiles();
        this.importOpen = true;
        this.importData = res.data.errorList;
        this.importSucceedNumber = res.data.succeedNumber;
        this.importErrorNumber = res.data.errorNumber;
        this.search();
      } else {
        this.$refs.upload.abort();
        this.$message.error(res.msg);
      }
    },
    importOpnes() {
      this.importOpen = false;
      this.importData = [];
      this.importSucceedNumber = 0;
      this.importErrorNumber = 0;
    },
    resetJoinTime() {
      this.joinTime = "";
      this.leaveTime = "";
    },
  },
};
</script>
<style scoped>
.title_box {
  width: 100%;
  height: 40px;
  background-color: #e6f7ff;
  box-shadow: rgba(186, 231, 255, 1) solid 1px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  margin: 20px 0;
}

.form_box .el-form-item {
  width: 46%;
}
</style>
